import { SendingPlatform } from '../constants';
import { EmailChannel } from '../types';

export * from './espAccounts';
export * from './form';
export * from './sendingPlatforms';
export * from './serviceProviders';
export * from './text';

export const sendingPlatformDetailsPath = (sendingPlatform: SendingPlatform) =>
  `/settings/sendingPlatforms/${sendingPlatform}`;

/**
 * If an ESP account does not exist, sends will be done via the Iterable SES
 * account.
 */

export const hasNoBindings = (emailChannel: EmailChannel) =>
  !emailChannel.espBindings || emailChannel.espBindings.length === 0;
